import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import api from "../../services/api";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const storeAuthData = ({ user, access_token, token_type, expires_in }) => {
  const expirationTime = new Date().getTime() + expires_in * 1000;

  localStorage.setItem("access_token", access_token);
  localStorage.setItem("token_type", token_type);
  localStorage.setItem("expires_in", expirationTime.toString());
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("isAuthenticated", "true");
};

const decodePayload = (payload) => {
  const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
  return JSON.parse(atob(padded));
};

const SSO = () => {
  const navigate = useNavigate();
  const { data } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const completeSso = async () => {
      const payload = searchParams.get("payload");

      if (!payload && !data) {
        navigate("/login?error=azure_sso");
        return;
      }

      try {
        let userData = null;

        if (payload) {
          userData = decodePayload(payload);
        } else if (UUID_REGEX.test(data)) {
          const response = await api.get(`/sso/exchange/${data}`);
          userData = response.data;
        } else {
          userData = JSON.parse(decodeURIComponent(data));
        }

        if (!userData?.access_token) {
          throw new Error("Missing access token");
        }

        storeAuthData(userData);
        navigate("/");
      } catch (error) {
        console.error("SSO connection failed:", error);
        navigate("/login?error=azure_sso");
      }
    };

    completeSso();
  }, [data, navigate, searchParams]);

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="loading-container">
        <img src="/favicon.ico" alt="Loading" className="loading-icon" />
        <div className="loading-text">Processing Single Sign-On...</div>
      </div>
    </div>
  );
};

export default SSO;
